/**
 * Error thrown when fetch returns a non-200 response.
 */
export class FetchError extends Error {
  constructor(readonly response: Response) {
    super(`${response.status} ${response.statusText}`);
    Object.setPrototypeOf(this, FetchError.prototype);
  }
}

export function isFetchError(error: Error) {
  return error instanceof FetchError || error.message.match(/failed to fetch/i);
}
